export default "<app-elenco-tariffe\n  [service]=\"service\"\n  [options] = \"options\"\n  [lastId] = lastId\n></app-elenco-tariffe>\n";